import { EventTicketsInfoList } from "./EventTicketsInfoList";
export default EventTicketsInfoList;
